import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'

export const RichPlacement1Section = (): JSX.Element => {
  return (
    <Paper>
      <SectionHeader title={'RichPlacement1Section'} />
    </Paper>
  )
}
